import { ModesDocumentVerificationAfterSigning } from "../types/applicationApiTypes";

export const isModesDocumentVerificationAfterSigning = (
  mode: string
): mode is ModesDocumentVerificationAfterSigning => {
  return (
    mode === ModesDocumentVerificationAfterSigning["standart_signing"] ||
    mode === ModesDocumentVerificationAfterSigning["resigning"]
  );
};
